import { OutputResult } from '../models/output-result.model';
import { OutputSelector } from './output-selector.interface';

export class Join implements OutputSelector {
	public select(outputs: OutputResult[]): string {
		const outputsExceptLast = outputs.slice(0, -1);
		const lastOutput = outputs.slice(-1)[0];
		const joinedOutputsExceptLast: string = outputsExceptLast.map(output => output.output).join(', ');
		return [joinedOutputsExceptLast, lastOutput.output].join(outputs.length < 2 ? '' : ' and ');
	}
}
